module.exports = __webpack_public_path__ + "img/zijinjihua.a156d5f2.png";